(function () {
    // 注册组件
    SR.modules.extend('events', events);

    function events() {
        if (!SR.state.isSmartRobot) {
            return;
        }
        var $body = SR.dom.$body;
        var $scrollWrap = SR.dom.$scrollWrap;
        var $scrollHelper = $('<div class="scroll-helper"><div class="button"></div></div>');
        var throttleTimer;
        var scrollHelperPosition = 500;
        var touchStartY;
        var touchEndY;
        var commonTimer;

        $body.on('click.ask', '.J_ask', function (e) {
            e.preventDefault();
            var $me = $(this);
            var content = $me.attr('data-question') || $me.text();
            var isAskAgain = $me.hasClass('repeat');
            var options = {};
            var option = $me.attr('data-option');
            if (option) {
                try {
                    option = JSON.parse(option);
                    options = Object.assign(options, option);
                } catch (err) {
                    console.warn('parse data-option error');
                }
            }
            if (isAskAgain) {
                var $last = $('.msg.me').last();
                var $content = $me.parent('.content');
                options.askAgain = 'reload';
                options.askId = $me.attr('data-askid');
                if (!$me.parents('.msg.me').is($last)) {
                    // 只有最后一个问题，才滑动到答案
                    options.scrollToAnswer = false;
                }
                $content.html(content);
            }
            if ($me.attr('data-loadhistory') === 'true') {
                options.isLoadHistory = true;
            }
            if (content) {
                window.ask(content, options);
            }
        });

        $scrollWrap.on('scroll.helper', function (e) {
            clearTimeout(throttleTimer);
            throttleTimer = setTimeout(function () {
                var initPosition = SR.dom.$wrapper.offset().top;
                var direction = initPosition > 0 ? 'go-down' : 'go-up';
                if (Math.abs(initPosition) > scrollHelperPosition) {
                    if ($scrollHelper.hasClass(direction)) {
                        return;
                    }
                    if ($body.find('.scroll-helper').length === 0) {
                        $body.append($scrollHelper);
                    }
                    $scrollHelper.removeClass('go-down go-up').addClass(direction);
                } else {
                    $scrollHelper.removeClass('go-down go-up');
                }
            }, 200);
        });
    
        $body.on('click', '.scroll-helper', function () {
            var $me = $(this);
            var initPosition = SR.dom.$historyWrapper.height() + 40;
            var goToPos = $me.hasClass('go-down') ? SR.dom.$wrapper.height() + SR.dom.$historyWrapper.height() : 15;
            $scrollWrap.stop(false, false).animate({
                scrollTop: goToPos
            }, 400, function () {
                $scrollHelper.removeClass('go-down go-up');
            });
        });

        // SR WebApp Event
        $body.on('click.SREvent', '.J_invokeSREvent', function (e) {
            e.preventDefault();
            var dataParams = $(this).attr('data-params');
            try {
                dataParams = JSON.parse(dataParams);
            } catch (err) {
                console.log('invokeSREvent error: dataParams pares error');
            }

            switch (dataParams.action) {
                case 'reload':
                    srReload(dataParams);
                    break;
            }
        });

        // App Event
        $body.on('click.AppEvent', '.J_invokeAppEvent', function (e) {
            e.preventDefault();
            if (!upNativeComm) {
                console.log('invokeAppEvent error: can not found upNativeComm');
                return;
            }
            var $me = $(this);
            var dataParams = $me.attr('data-params');
            var actionType = $me.attr('data-actionType');
            SR.state.isDebug && console.log('actionType: ' + actionType);

            if (!dataParams || actionType === 'wait') {
                return;
            }
            try {
                dataParams = JSON.parse(dataParams);
                // mulitParams 参数透传
                if (SR.state.customMulitParams && dataParams.url && dataParams.url.length && SR.data.mulitParams) {
                    var connector = dataParams.url.indexOf('?') !== -1 ? '&' : '?';
                    dataParams.url += connector + 'srmp=' + SR.data.mulitParams;
                    SR.state.isDebug && console.log('mulitParams: ' + SR.data.mulitParams);
                }
            } catch (err) {
                console.log('invokeAppEvent error: dataParams pares error');
            }
            
            SR.App.trigger('invokeApp', [dataParams]);
            SR.state.isDebug && console.log(dataParams);

            switch (dataParams.action) {
                case 'login':
                    appLogin(dataParams);
                    break;
                case 'viewInWebview':
                    viewInWebview(dataParams);
                    break;
                case 'viewInNative':
                    viewInNative(dataParams);
                    break;
            }
        });

        $body.on('touchstart', '.tapHighLight', function (e) {
            touchStartY = e.changedTouches[0].clientY;
        }).on('touchend touchcancel', '.tapHighLight', function (e) {
            touchEndY = e.changedTouches[0].clientY;
            if (Math.abs(touchStartY - touchEndY) < 10) {
                var $me = $(this);
                $me.addClass('active');
                setTimeout(function () {
                    $me.removeClass('active');
                }, 200);
            }
        });

        $body.on('click', '.msg.me .content', function (e) {
            var question = $(this).text();
            var $target = $(e.target);
            var $msg = $target.parents('.msg');
            if ($target.hasClass('repeat') || $msg.hasClass('speakVoice') || !question) {
                return;
            }
            if (SR.state.isH5) {
                SR.dom.$askBar.find('.ask-bar-input').val(question);
            } else if (SR.state.isNative && !SR.state.isDebug) {
                upNativeComm.exec('smartRobot.setInputText', {
                    'text': question
                });
            }
        });

        $body.on('click', '.J_analytics', function() {
            var data = $(this).attr('data-analytics');
            if (data) {
                data = JSON.parse(data);
                SR.modules.triggerAnalytics.uploadData(data);
            }
        });

        $body.on('touchstart.hideKeyboard touchmove.hideKeyboard', function (e) {
            SR.App.trigger('hideKeyboard');
        });
        
        SR.App.on('onShow', function() {
            if (commonTimer) {
                clearTimeout(commonTimer);
            }
            // 重问 SR.data.askAgain 中的问题
            // 目前应用场景：
            // * 智能组合，登录跳转，bindEvents.js
            if (SR.data.askAgain.length) {
                $(SR.data.askAgain).each(function(index, item) {
                    if (item.question) {
                        window.ask(item.question, {
                            askAgain: item.askType,
                            askId: item.askId
                        });
                    }
                });
                SR.data.askAgain = []; // 清空问题
            }
        });

        SR.App.on('onHide', function() {
            //当场景切换的时候清除video和audio
            $('.video-player-wrap').remove();
            $('.tts-audio').remove();
        });

        var hideKeyboard = SR.util.throttle(function() {
            SR.state.isNative && !SR.state.isDebug && upNativeComm.exec('smartRobot.hideKeyboard');
        }, 200);

        SR.App.on('hideKeyboard', function() {
            // 大师兄使用的并不是 document 的 scroll，所以 App 无法监测到，需要手动隐藏键盘
            if (SR.data.deviceInfo.os.name === 'iOS' && Number(SR.data.deviceInfo.os.version.split('.')[0]) >= 13) {
                // 修复 iOS 13 下调用 upNativeComm.exec 导致页面无法交互的问题
            } else {
                hideKeyboard();
            }
        });

        // 事件函数 ---------------------------------------------------------

        // 刷新大师兄
        function srReload(dataParams) {
            switch (dataParams.iCmd) {
                // 兼容 4.5.3 以下版本
                case 30:
                    var lastQuestion = SR.data.questions[SR.data.questions.length - 1];
                    localStorage.setItem('askAgainCache', lastQuestion);
                    break;
            }
            location.reload();
        }

        // App 登录
        function appLogin(dataParams) {
            var login = {
                callback: function (code, param) {
                    var param = JSON.parse(param);
                    if (param.ret === 0) {
                        // if (dataParams.iCmd === 30) {
                        //     var lastQuestion = SR.data.questions[SR.data.questions.length - 1];
                        //     localStorage.setItem('askAgainCache', lastQuestion);
                        //     location.reload();
                        // }
                    }
                }
            }
            if (SR.state.isNative) {
                if (SR.state.deprecatedSDK) {
                    upNativeComm.exec('Navigation.userLogin', login);
                } else {
                    location.href = 'upchina://user/login';
                }
            }
        }

        // 打开 Webview 界面
        function viewInWebview(dataParams) {
            var iCmd = dataParams.iCmd;
            var url = dataParams.url;

            if (dataParams.type === 'lbs') {

            } else {
                // 当没有传 type 时，默认为 Stock
                switch (iCmd) {
                    case 1:
                        // 个股行情
                        var fullCode = '0' + dataParams.market + '00' + dataParams.sCode;
                        url = 'http://q.upchina.com/stock/hs/' + fullCode;
                        break;
                    case 13:
                        url = 'http://q.upchina.com/hq/list/zf';
                        break;
                    case 14:
                        url = 'http://q.upchina.com/hq/list/df';
                        break;
                    case 23:
                        url = 'http://q.upchina.com/hq/list/bk';
                        break;
                }
            }
            if (!url) {
                console.log('viewInWebview error: url is undefined');
                return;
            }
            if (SR.state.isNative) {
                !SR.state.isDebug && upNativeComm.exec('WebView.open', {
                    url: url
                });
            } else {
                location.href = url;
            }
        }

        // 打开 Native 界面
        function viewInNative(dataParams) {
            if (SR.state.isNative) {
                if (SR.state.deprecatedSDK) {
                    // 4.x App 处理，需要 iCmd、市场代码、股票代码、板块代码
                    if (dataParams.url && dataParams.url.indexOf('openurl://') === 0) {
                        upNativeComm.exec('smartRobot.srWebView', dataParams);
                    } else {
                        upNativeComm.exec('smartRobot.srContentView', dataParams);
                    }
                } else {
                    // 5.x App 处理
                    if (dataParams.url && dataParams.url.length) {
                        !SR.state.isDebug && upNativeComm.exec('WebView.open', {
                            url: dataParams.url
                        });
                    }
                }
            } else {
                viewInWebview(dataParams);
            }
        }

        // App 新事件绑定方式
        if (SR.state.isNative && !SR.state.isDebug) {
            // 解绑 visibilitychange 事件
            SR.dom.$document.off(SR.data.events.visibilityChangeEvent);

            upNativeComm.addEventListener('smartRobot', function (opt) {
                if (!opt) {
                    return;
                }
                switch(opt.action) {
                    case 'ask':
                        if (Number(opt.isVoice) === 1) {
                            window.ask(opt.question, {inputType: 1});
                        } else {
                            window.ask(opt.question, {inputType: 0});
                        }
                    break;
                    case 'inputChange':
                        if (SR.state.askMode !== 'staff') {
                            SR.component.autoComplete.getSuggestion(opt.question);
                        }
                    break;
                }
            });

            upNativeComm.addEventListener('WebView', function (opt) {
                if (!opt) {
                    return;
                }
                switch(opt.action) {
                    case 'invisible':
                        // 离开当前页面
                        SR.lifecycle.hide('sdk');
                    break;
                    case 'visible':
                        // 返回当前页面
                        SR.lifecycle.show('sdk');
                    break;
                }
            });

            upNativeComm.addEventListener('UPUser', function(opt) {
                if (opt.action === 'userChange') {
                    if (opt.uid && opt.uid.length) {
                        SR.data.userInfo.uid = opt.uid;
                        if (opt.avatar) {
                            SR.data.userInfo.userAvatar = opt.avatar;
                        }
                    }
                }
            }); 
        }
    }
}());